import { render, staticRenderFns } from "./addcard.vue?vue&type=template&id=fbf7e92e&scoped=true"
import script from "./addcard.vue?vue&type=script&lang=js"
export * from "./addcard.vue?vue&type=script&lang=js"
import style0 from "./addcard.vue?vue&type=style&index=0&id=fbf7e92e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf7e92e",
  null
  
)

export default component.exports